// extracted by mini-css-extract-plugin
export default {"mapBody":"map_mapBody__+CncR","header":"map_header__qxH++"};